import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { AxiosResponse } from 'axios';
import { useMemo } from 'react';
import { GalaxyService, getServicesApi } from 'TenantModule/api/getServicesApi';
import { serviceQueryKeys } from './serviceQueryKeys';

/**
 * Fetches every non-archived service registered in galaxy-server (GET /service),
 * sorted alphabetically by display name.
 */
export const useServicesQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const query = useAppQuery<AxiosResponse<GalaxyService[]>>({
    queryKey: serviceQueryKeys.list({ identifier: 'useServicesQuery' }),
    queryFn: ({ token, buildConfig }) =>
      getServicesApi({ params: undefined, token, config: buildConfig() }),
    staleTime: 5 * 60 * 1000, // 5 minutes — the service catalog changes infrequently
    enabled,
  });

  const services: GalaxyService[] = useMemo(() => {
    const raw = query.data?.data;
    if (!Array.isArray(raw)) return [];
    return [...raw].sort((a, b) =>
      (a.serviceDisplayName || a.serviceName).localeCompare(b.serviceDisplayName || b.serviceName),
    );
  }, [query.data?.data]);

  return {
    services,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
